import { TGetStockBalancesQuery } from '../helpers/types';

export class GetStockBalancesListDTO {
  page?: number;
  limit?: number;
  region_id?: string;
  sku?: string;
  name?: string;
  external_id?: string;
  search?: string;
  active?: boolean;
  available?: boolean;
  quantity_min?: number;
  quantity_max?: number;
  price_min?: number;
  price_max?: number;
  discount_price_min?: number;
  discount_price_max?: number;
  store_ids?: string[];
  partner_ids?: string[];
  category_ids?: string[];

  constructor(data: TGetStockBalancesQuery) {
    this.page = data.page ?? 1;
    this.limit = data.limit ?? 25;
    this.region_id = data.region_id;
    this.sku = data.sku;
    this.name = data.name;
    this.external_id = data.external_id;
    this.search = data.search;
    this.active = data.active;
    this.available = data.available;
    this.quantity_min = data.quantity_min;
    this.quantity_max = data.quantity_max;
    this.price_min = data.price_min;
    this.price_max = data.price_max;
    this.discount_price_min = data.discount_price_min;
    this.discount_price_max = data.discount_price_max;
    this.store_ids = data.store_ids;
    this.partner_ids = data.partner_ids;
    this.category_ids = data.category_ids;
  }
}
